import React, { useRef } from 'react';
import { View, StyleSheet, Animated, ScrollView } from 'react-native';
import NavBar from 'src/presentation/components/organisms/NavBar';
import Heading from 'src/presentation/components/atoms/Heading';
import EditProfileForm from 'src/presentation/components/organisms/forms/EditProfileForm';
import { useNavigationStore } from 'src/domain/stores/useNavigationStore';
import { useAuthenticationStore } from 'src/domain/stores/useAuthenticationStore';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import Translations from 'src/core/utils/Translations';
import Constants from 'src/core/utils/Constants';

function EditProfileScreen() {
	const navigationStore = useNavigationStore();
	const authStore = useAuthenticationStore();

	const keyboardHeight = useRef(new Animated.Value(0)).current;

	if (authStore.proceedToApp) {
		navigationStore.navigate(Constants.screenIndex);
	}

	return (
		<View style={{ flex: 1 }}>
			<NavBar
				backBtn={true}
				bgcolor={Colors.primary}
				centerTitle={true}
				color={Colors.black}
				editBtn={false}
				title={Translations.titleProfile}
			/>
			<ScrollView keyboardShouldPersistTaps="always" style={{ backgroundColor: Colors.white }}>
				<Animated.View style={{ paddingBottom: keyboardHeight }}>
					<View style={styles.contentContainer}>
						<Heading text={Translations.titleEditProfile} />
					</View>
					<EditProfileForm />
				</Animated.View>
			</ScrollView>
		</View>
	);
}

export default EditProfileScreen;

const styles = StyleSheet.create({
	contentContainer: {
		paddingLeft: Dimens.padding20,
		paddingRight: Dimens.padding20,
		paddingTop: Dimens.padding20,
	},
});
